import { useState , useRef, useEffect} from "react";
import Sider from "../../comps/sider/main";
import style from "./main.css"
import { Popconfirm , Alert, Skeleton, Card, message, Col, Row, Statistic, Tooltip, Empty, Button, Collapse, Popover, Divider, Modal, Segmented, Tag, Drawer, Space, Input, Upload, InputNumber, Select, Switch } from "antd";

import {useEditor, EditorProvider, FloatingMenu, BubbleMenu } from '@tiptap/react'

import StarterKit from '@tiptap/starter-kit'
import Underline from '@tiptap/extension-underline'
import Link from '@tiptap/extension-link'
import Youtube from '@tiptap/extension-youtube'
import Heading from '@tiptap/extension-heading'
import { EditorContent } from '@tiptap/react'



import {
  BoldOutlined,
  ItalicOutlined,
  UnderlineOutlined,
  FontSizeOutlined,
  LinkOutlined,
  YoutubeOutlined,
  PlusOutlined,
  UploadOutlined,
  InboxOutlined,
  PictureOutlined,
  CopyOutlined,
  FolderAddOutlined,
  DollarOutlined
} from '@ant-design/icons'



const MenuBar = ({ editor }) => {
  const [isLinkModalOpen, setLinkModalOpen] = useState(false)
  const [isYTModalOpen, setYTModalOpen] = useState(false)
  const [linkUrl, setLinkUrl] = useState('')
  const [ytUrl, setYTUrl] = useState('')

  if (!editor) return null

  const insertLink = () => {
    if (linkUrl) {
      editor.chain().focus().setLink({ href: linkUrl }).run()
      setLinkModalOpen(false)
      setLinkUrl('')
    }
  }

  const insertYT = () => {
    if (ytUrl) {
      editor.chain().focus().setYoutubeVideo({ src: ytUrl }).run()
      setYTModalOpen(false)
      setYTUrl('')
    }
  }

  return (
    <>
      <div className="menu-bar">
        <Space>
          <Tooltip title="Bold">
            <Button 
              type={editor.isActive('bold') ? 'primary' : 'default'} 
              icon={<BoldOutlined />} 
              onClick={() => editor.chain().focus().toggleBold().run()} 
            />
          </Tooltip>

          <Tooltip title="Italic">
            <Button 
              type={editor.isActive('italic') ? 'primary' : 'default'} 
              icon={<ItalicOutlined />} 
              onClick={() => editor.chain().focus().toggleItalic().run()} 
            />
          </Tooltip>

          <Tooltip title="Underline">
            <Button 
              type={editor.isActive('underline') ? 'primary' : 'default'} 
              icon={<UnderlineOutlined />} 
              onClick={() => editor.chain().focus().toggleUnderline().run()} 
            />
          </Tooltip>

          <Tooltip title="Heading 2">
            <Button 
              type={editor.isActive('heading', { level: 2 }) ? 'primary' : 'default'} 
              icon={<FontSizeOutlined />} 
              onClick={() => editor.chain().focus().toggleHeading({ level: 2 }).run()} 
            />
          </Tooltip>

          <Tooltip title="Insert Link">
            <Button icon={<LinkOutlined />} onClick={() => setLinkModalOpen(true)} />
          </Tooltip>

          <Tooltip title="Embed YouTube">
            <Button icon={<YoutubeOutlined />} onClick={() => setYTModalOpen(true)} />
          </Tooltip>
        </Space>
      </div>

      {/* Link Modal */}
      <Modal
        title="Insert Link"
        open={isLinkModalOpen}
        onOk={insertLink}
        onCancel={() => setLinkModalOpen(false)}
        okText="Insert"
      >
        <Input
          placeholder="https://example.com"
          value={linkUrl}
          onChange={(e) => setLinkUrl(e.target.value)}
        />
      </Modal>

      {/* YouTube Modal */}
      <Modal
        title="Embed YouTube Video"
        open={isYTModalOpen}
        onOk={insertYT}
        onCancel={() => setYTModalOpen(false)}
        okText="Embed"
      >
        <Input
          placeholder="https://www.youtube.com/watch?v=xyz"
          value={ytUrl}
          onChange={(e) => setYTUrl(e.target.value)}
        />
      </Modal>
    </>
  )
}


const MyEditor = ({ data, onChange, editorBlock }) => {

  const editor = useEditor({
    extensions: [
      StarterKit,
      Underline,
      Link.configure({
        openOnClick: false,
      }),
      Youtube.configure({
        width: 640,
        height: 360,
      }),
      Heading.configure({
        levels: [1, 2, 3],
      }),
    ],
    content: data || "Click to add description, youtube video, link to platfrom and more.",
    onUpdate: ({ editor }) => {
      onChange?.(editor.getHTML())
    },
  })

  


  return (
    <div className="editor-wrapper">
      <MenuBar editor={editor} />
      <EditorContent editor={editor} />
    </div>
  )
}


const PriceComp = ({data, onChange, compType}) => {

  let supported_currency = [
    { "label": "🇮🇳 Indian Rupee (₹)", "value": "INR" },
    { "label": "🇺🇸 US Dollar ($)", "value": "USD" },
    { "label": "🇮🇩 Indonesian Rupiah (Rp)", "value": "IDR" },
    { "label": "🇦🇪 UAE Dirham (د.إ)", "value": "AED" },
    { "label": "🇦🇱 Albanian Lek (L)", "value": "ALL" },
    { "label": "🇦🇲 Armenian Dram (֏)", "value": "AMD" },
    { "label": "🇦🇷 Argentine Peso ($)", "value": "ARS" },
    { "label": "🇦🇺 Australian Dollar ($)", "value": "AUD" },
    { "label": "🇦🇼 Aruban Florin (Afl)", "value": "AWG" },
    { "label": "🇦🇿 Azerbaijan Manat (₼)", "value": "AZN" },
    { "label": "🇧🇦 Convertible Mark (KM)", "value": "BAM" },
    { "label": "🇧🇧 Barbadian Dollar (Bds$)", "value": "BBD" },
    { "label": "🇧🇩 Bangladeshi Taka (৳)", "value": "BDT" },
    { "label": "🇧🇬 Bulgarian Lev (лв)", "value": "BGN" },
    { "label": "🇧🇭 Bahraini Dinar (.د.ب)", "value": "BHD" },
    { "label": "🇧🇮 Burundi Franc (FBu)", "value": "BIF" },
    { "label": "🇧🇲 Bermudian Dollar ($)", "value": "BMD" },
    { "label": "🇧🇳 Brunei Dollar (B$)", "value": "BND" },
    { "label": "🇧🇴 Bolivian Boliviano (Bs.)", "value": "BOB" },
    { "label": "🇧🇷 Brazilian Real (R$)", "value": "BRL" },
    { "label": "🇧🇸 Bahamian Dollar (B$)", "value": "BSD" },
    { "label": "🇧🇹 Bhutanese Ngultrum (Nu.)", "value": "BTN" },
    { "label": "🇧🇼 Botswana Pula (P)", "value": "BWP" },
    { "label": "🇧🇿 Belize Dollar (BZ$)", "value": "BZD" },
    { "label": "🇨🇦 Canadian Dollar (C$)", "value": "CAD" },
    { "label": "🇨🇭 Swiss Franc (CHF)", "value": "CHF" },
    { "label": "🇨🇱 Chilean Peso ($)", "value": "CLP" },
    { "label": "🇨🇳 Chinese Yuan (¥)", "value": "CNY" },
    { "label": "🇨🇴 Colombian Peso ($)", "value": "COP" },
    { "label": "🇨🇷 Costa Rican Colón (₡)", "value": "CRC" },
    { "label": "🇨🇺 Cuban Peso (CUP)", "value": "CUP" },
    { "label": "🇨🇿 Czech Koruna (Kč)", "value": "CZK" },
    { "label": "🇩🇯 Djiboutian Franc (Fdj)", "value": "DJF" },
    { "label": "🇩🇰 Danish Krone (kr)", "value": "DKK" },
    { "label": "🇩🇴 Dominican Peso (RD$)", "value": "DOP" },
    { "label": "🇩🇿 Algerian Dinar (د.ج)", "value": "DZD" },
    { "label": "🇪🇬 Egyptian Pound (E£)", "value": "EGP" },
    { "label": "🇪🇹 Ethiopian Birr (Br)", "value": "ETB" },
    { "label": "🇪🇺 Euro (€)", "value": "EUR" },
    { "label": "🇫🇯 Fijian Dollar (FJ$)", "value": "FJD" },
    { "label": "🇬🇧 British Pound (£)", "value": "GBP" },
    { "label": "🇬🇭 Ghanaian Cedi (₵)", "value": "GHS" },
    { "label": "🇭🇰 Hong Kong Dollar (HK$)", "value": "HKD" },
    { "label": "🇭🇷 Croatian Kuna (kn)", "value": "HRK" },
    { "label": "🇭🇺 Hungarian Forint (Ft)", "value": "HUF" },
    { "label": "🇮🇱 Israeli Shekel (₪)", "value": "ILS" },
    { "label": "🇮🇶 Iraqi Dinar (ع.د)", "value": "IQD" },
    { "label": "🇮🇸 Icelandic Krona (kr)", "value": "ISK" },
    { "label": "🇯🇵 Japanese Yen (¥)", "value": "JPY" },
    { "label": "🇰🇪 Kenyan Shilling (KSh)", "value": "KES" },
    { "label": "🇰🇷 South Korean Won (₩)", "value": "KRW" },
    { "label": "🇰🇼 Kuwaiti Dinar (د.ك)", "value": "KWD" },
    { "label": "🇱🇰 Sri Lankan Rupee (Rs)", "value": "LKR" },
    { "label": "🇲🇾 Malaysian Ringgit (RM)", "value": "MYR" },
    { "label": "🇲🇽 Mexican Peso ($)", "value": "MXN" },
    { "label": "🇳🇬 Nigerian Naira (₦)", "value": "NGN" },
    { "label": "🇳🇴 Norwegian Krone (kr)", "value": "NOK" },
    { "label": "🇳🇿 New Zealand Dollar ($)", "value": "NZD" },
    { "label": "🇴🇲 Omani Rial (﷼)", "value": "OMR" },
    { "label": "🇵🇰 Pakistani Rupee (Rs)", "value": "PKR" },
    { "label": "🇵🇭 Philippine Peso (₱)", "value": "PHP" },
    { "label": "🇵🇱 Polish Złoty (zł)", "value": "PLN" },
    { "label": "🇶🇦 Qatari Riyal (﷼)", "value": "QAR" },
    { "label": "🇷🇺 Russian Ruble (₽)", "value": "RUB" },
    { "label": "🇸🇦 Saudi Riyal (﷼)", "value": "SAR" },
    { "label": "🇸🇪 Swedish Krona (kr)", "value": "SEK" },
    { "label": "🇸🇬 Singapore Dollar (S$)", "value": "SGD" },
    { "label": "🇿🇦 South African Rand (R)", "value": "ZAR" },
    { "label": "🇿🇲 Zambian Kwacha (ZK)", "value": "ZMW" }
  ];
    const [currency, setCurrency] = useState(data?.currency || 'INR');
    const [price, setPrice] = useState(data?.price || null);
    const [offerPrice, setOfferPrice] = useState(data?.offerPrice || null);
  
    const [directPayEnabled, setDirectPayEnabled] = useState(data?.directPayEnabled || false);
    const [upiId, setUpiId] = useState(data?.upiId || '');
    const [manualPaymentDetails, setManualPaymentDetails] = useState(data?.manualPaymentDetails || '');
  
    const [devicePricingEnabled, setDevicePricingEnabled] = useState(data?.devicePricingEnabled || false);
    const [androidPrice, setAndroidPrice] = useState(data?.androidPrice || null);
    const [iosPrice, setIosPrice] = useState(data?.iosPrice || null);
  
    const [userCanChoosePrice, setUserCanChoosePrice] = useState(data?.userCanChoosePrice || false);
    const [userMinPrice, setuserMinPrice] = useState(data?.userMinPrice || null);
    const [userMaxPrice, setuserMaxPrice] = useState(data?.userMaxPrice || null);
  
    const [limitedSalesEnabled, setLimitedSalesEnabled] = useState(data?.limitedSalesEnabled || false);
    const [limitedSalesCount, setLimitedSalesCount] = useState(data?.limitedSalesCount || null);
  
    useEffect(() => {
      onChange?.({
        currency,
        price,
        offerPrice,
        directPayEnabled,
        upiId,
        manualPaymentDetails,
        devicePricingEnabled,
        androidPrice,
        iosPrice,
        userCanChoosePrice,
        userMinPrice,
        userMaxPrice,
        limitedSalesEnabled,
        limitedSalesCount
      });
    }, [
      currency, price, offerPrice,
      directPayEnabled, upiId, manualPaymentDetails,
      devicePricingEnabled, androidPrice, iosPrice,
      userCanChoosePrice, userMinPrice, userMaxPrice,
      limitedSalesEnabled, limitedSalesCount
    ]);


    const AdvOptions = () => (
      <div>
        {/* Direct Pay Option */}
        <div style={sectionStyle}>
          <h4 style={{ margin: 0 }}>
            <Switch checked={directPayEnabled} onChange={setDirectPayEnabled} /> Direct Payment - Verify Payment Manually
          </h4>
          
        </div>
        <p>Directly reccive payment in your wallet, UPI, or Bank account.</p>
       { directPayEnabled &&
       
       <>
       <Input
          placeholder="Enter your UPI ID (For Indian Payments only)"
          value={upiId}
          onChange={(e) => setUpiId(e.target.value)}
          disabled={!directPayEnabled}
        /> <Divider>Or upload QR Code or Bank details </Divider>
         <Input.TextArea
          minLength={6}
          placeholder="Bank details or wallet details or instructions"
          value={manualPaymentDetails}
          onChange={(e) => setManualPaymentDetails(e.target.value)}
          disabled={!directPayEnabled}
        />
        </>
        }
  
        {/* Device Based Pricing */}
        <div style={sectionStyle}>
          <h4 style={{ margin: 0 }}>
            <Switch checked={devicePricingEnabled} onChange={setDevicePricingEnabled} /> Device Based Pricing
          </h4>
        </div>
        <p>Give customized discounts based user device.</p>
        { devicePricingEnabled &&
       
       <>
        <InputNumber
          style={inputStyle}
          placeholder="Android Price"
          value={androidPrice}
          onChange={setAndroidPrice}
          disabled={!devicePricingEnabled}
        />
        <InputNumber
          style={inputStyle}
          placeholder="iOS/Apple Price"
          value={iosPrice}
          onChange={setIosPrice}
          disabled={!devicePricingEnabled}
        />
        </>}
  
        {/* Let user decide price */}
        <div style={sectionStyle}>
          <h4 style={{ margin: 0 }}>
            <Switch checked={userCanChoosePrice} onChange={setUserCanChoosePrice} /> Let user Decide Price
          </h4>
        </div>
        <p>Let user pay whatever they want.</p>
        { userCanChoosePrice &&
       
       <>
        <InputNumber
          style={inputStyle}
          placeholder="Minimum Price"
          value={userMinPrice}
          onChange={setuserMinPrice}
          disabled={!userCanChoosePrice}
        />
        <InputNumber
          style={inputStyle}
          placeholder="Maximum Price"
          value={userMaxPrice}
          onChange={setuserMaxPrice}
          disabled={!userCanChoosePrice}
        />

        </>}
  
        {/* Limited Sales */}
        <div style={sectionStyle}>
          <h4 style={{ margin: 0 }}>
            <Switch checked={limitedSalesEnabled} onChange={setLimitedSalesEnabled} /> Limited Sales
          </h4>
        </div>
        <p>Limit sales to specific number.</p>
        { limitedSalesEnabled &&
       
       <><InputNumber
          style={inputStyle}
          placeholder="No. of sales"
          value={limitedSalesCount}
          onChange={setLimitedSalesCount}
          disabled={!limitedSalesEnabled}
        />
        </>}
      </div>
    );
  
    const adv_options = [
      {
        key: '1',
        label: 'Advanced Options & Direct Payment',
        children: <AdvOptions />,
      }
    ];
  
    const sectionStyle = {
      display: 'flex',
      flexDirection: 'row',
      marginTop: '20px',
      gap: '10px',
      alignItems: 'center',
      marginBottom: '10px'
    };
  
    const inputStyle = { width: '48%', marginRight: '10px' };
  
    return (
      <div className="action-box">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h4 style={{ marginBottom: "10px" }}>
            <DollarOutlined className="icon follow" /> Price
          </h4>
        </div>
        <Select
          options={supported_currency}
          style={{ width: "100%", marginBottom: "10px" }}
          value={currency}
          onChange={setCurrency}
        />
        <div style={{ display: "flex", flexDirection: "row" }}>
          <InputNumber
            placeholder="Price"
            style={{ width: "40%", marginRight: "10px" }}
            value={price}
            onChange={setPrice}
          />
          <InputNumber
            placeholder="Offer Price"
            style={{ width: "40%" }}
            value={offerPrice}
            onChange={setOfferPrice}
          />
        </div>
        <Collapse style={{ marginTop: "10px" }} items={adv_options} />
      </div>
    );

  };




const MediaComp = ({ data = [], onChange, compType }) => {
  const [mediaItems, setMediaItems] = useState(data);
  const [youtubeModalVisible, setYoutubeModalVisible] = useState(false);
  const [youtubeUrl, setYoutubeUrl] = useState("");

  const maxItems = 5;

  const handleFileChange = async ({ fileList }) => {
    if (fileList.length + mediaItems.filter(item => item.type === 'youtube').length > maxItems) {
      message.error("You can only upload up to 5 items.");
      return;
    }

    const newItems = fileList.map(file => ({
      type: "image",
      file,
      preview: file.thumbUrl || URL.createObjectURL(file.originFileObj),
    }));

    // let path = `${product_id}_${image_index}`
    // let url = await uploadFileToS3(file, path);

    const youtubeItems = mediaItems.filter(item => item.type === "youtube");

    const updatedItems = [...newItems, ...youtubeItems];
    setMediaItems(updatedItems);
    // onChange(updatedItems);
  };

  const handleAddYoutube = () => {
    if (!youtubeUrl) {
      message.error("Please enter a YouTube URL.");
      return;
    }

    const youtubeId = extractYoutubeId(youtubeUrl);
    if (!youtubeId) {
      message.error("Invalid YouTube URL.");
      return;
    }

    if (mediaItems.length >= maxItems) {
      message.error("You can only upload up to 5 items.");
      return;
    }

    const newItem = {
      type: "youtube",
      url: `https://www.youtube.com/embed/${youtubeId}`,
    };

    const updatedItems = [...mediaItems, newItem];
    setMediaItems(updatedItems);
    // onChange(updatedItems);
    setYoutubeModalVisible(false);
    setYoutubeUrl("");
  };

  const extractYoutubeId = (url) => {
    const regex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&\n?#]+)/;
    const match = url.match(regex);
    return match ? match[1] : null;
  };

  const handleRemove = (index) => {
    const updatedItems = mediaItems.filter((_, i) => i !== index);
    setMediaItems(updatedItems);
    onChange(updatedItems);
  };

  const uploadButton = (
    <div>
      <PlusOutlined />
      <div style={{ marginTop: 8 }}>Upload</div>
    </div>
  );


  
          
        
  return (
    <div className="action-box">
      <div style={{ display: 'flex', flexDirection: "row", justifyContent: 'space-between', alignItems: 'center', alignItems: 'center', marginBottom:"20px" }}>
            <h4>
              <PictureOutlined className="icon follow" /> Picture & Videos
            </h4>
            <Button
              onClick={() => setYoutubeModalVisible(true)}
              icon={<YoutubeOutlined />}
              className="mt-4"
              // disabled={mediaItems.length >= maxItems}
            >
              Add YouTube Video
            </Button>
          </div>

      <Upload
        
        accept="image/*"
        multiple
        listType="picture-card"
        fileList={mediaItems.filter(item => item.type === "image").map((item, index) => ({
          uid: index,
          name: item.file.name,
          status: 'done',
          url: item.preview,
        }))}
        
        beforeUpload={() => false} // prevent auto upload
        onChange={handleFileChange}
        onRemove={(file) => {
          const index = mediaItems.findIndex(
            (item) => item.file?.uid === file.uid || item.preview === file.url
          );
          handleRemove(index);
          return false;
        }}
        disabled={mediaItems.length >= maxItems}
      >
        {mediaItems.length < maxItems && uploadButton}
      </Upload>

      {/* Render YouTube Videos */}
      <div className="grid grid-cols-2 gap-4">
        {mediaItems.filter(item => item.type === "youtube").map((item, index) => (
          <div key={index} style={{display:"flex", flexDirection:"column", maxWidth:"300px", gap:"10px"}} className="relative">
            <iframe
              src={item.url}
              className="w-full h-32 rounded"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              title="YouTube Video"
            />
            <Button
              size="small"
              danger
              type="primary"
              onClick={() => handleRemove(mediaItems.findIndex(m => m.url === item.url))}
            >
              Remove
            </Button>
          </div>
        ))}
      </div>

      <Modal
        title="Add YouTube Video"
        open={youtubeModalVisible}
        onOk={handleAddYoutube}
        onCancel={() => setYoutubeModalVisible(false)}
        okText="Add"
      >
        <Input
          placeholder="Enter YouTube URL"
          value={youtubeUrl}
          onChange={(e) => setYoutubeUrl(e.target.value)}
        />
      </Modal>
    </div>
  );
};


const Adhoc = ({ data = [], onChange, compType }) => {

  return(
    <div>

      <h3>Before Purchase</h3>
      <p>1. Collect information</p>
      <p>2. Button Name</p>
      
      <h3>After Purchase</h3>
      <p>1. Redirect url</p>


      <h3>Policies</h3>
      <p>1. Refund Policy</p>
      <p>2. Privacy Policy</p>

    </div>
  )

}

const { Dragger } = Upload;

const DigitalMedias = ({ data = [], onChange }) => {
  const [fileList, setFileList] = useState(data);

  const maxFiles = 10;
  const maxFileSizeMB = 5; // Max 5 MB per file

  const handleChange = ({ fileList: newFileList }) => {
    if (newFileList.length > maxFiles) {
      message.error(`You can only upload up to ${maxFiles} files.`);
      return;
    }
    setFileList(newFileList);
    // onChange(newFileList.map(file => ({
    //   name: file.name,
    //   url: file.url || (file.originFileObj && URL.createObjectURL(file.originFileObj)),
    // })));
  };

  const beforeUpload = (file) => {
    const isAllowedSize = file.size / 1024 / 1024 < maxFileSizeMB;
    if (!isAllowedSize) {
      message.error(`File "${file.name}" is too large. Max size is ${maxFileSizeMB}MB.`);
      return Upload.LIST_IGNORE;
    }
    return true;
  };

  return (
    <div className="action-box">
    <div style={{ display: 'flex', flexDirection: "row", justifyContent: 'space-between', alignItems: 'center', alignItems: 'center' }}>
      <h4 style={{ marginBottom: "10px" }}>
        <FolderAddOutlined className="icon follow" /> Digital Products
      </h4>
    </div>

    <Dragger
      multiple
      fileList={fileList}
      beforeUpload={beforeUpload}
      onChange={handleChange}
      onRemove={(file) => {
        const updatedList = fileList.filter(item => item.uid !== file.uid);
        setFileList(updatedList);
        onChange(updatedList.map(file => ({
          name: file.name,
          url: file.url || (file.originFileObj && URL.createObjectURL(file.originFileObj)),
        })));
      }}
      accept="image/*,video/*,application/pdf" // optional: allow only specific types
      style={{ padding: '20px' }}
    >
      <p className="ant-upload-drag-icon">
        <InboxOutlined />
      </p>
      <p className="ant-upload-text">Click or drag digital products here to upload</p>
      <p className="ant-upload-hint">
        You can upload up to {maxFiles} files. Each file must be less than {maxFileSizeMB}MB.
      </p>
    </Dragger>
    </div>
  );
};


function SellDigitalProduct(){
    const [description, setDescription] = useState("Hello world.")
    return(
      <div style={{display:"flex", flexDirection:"column", gap:"20px"}}>
      <div className="action-box">
        <div style={{ display: 'flex', flexDirection: "row", justifyContent: 'space-between', alignItems: 'center', alignItems: 'center' }}>
          <h4 style={{ marginBottom: "10px" }}>
            <FontSizeOutlined className="icon follow" /> Title & Description
          </h4>
        </div>
        <div style={{ marginBottom: "20px" }}>
          <Input placeholder="Title" style={{marginBottom:"20px"}} />
          <MyEditor data={description} />
        </div>
      </div>

      

    <MediaComp/>
    
    <PriceComp/>
    
    <DigitalMedias/>

    <Divider></Divider>

    <Adhoc/>

    </div>
    )
}

export default function SellMain(){
    const [messageApi, contextHolder] = message.useMessage();

    const [showCreateDrawer, setShowCreateDrawer] = useState(false)

    return(
        <div className="page-layout"  style={{backgroundImage: 'linear-gradient(180deg, #f4e9f9 0%, #e9f0fc 100%)'}}>
            
            {contextHolder}

            <Sider/>
            <div className="page-content">

                <div className="sell-list">
                    <div className="sell-card" onClick={() => setShowCreateDrawer("digital_prod")}>
                        <img src="https://public-assets.instantdm.com/app-icons/sell_11764602.png"/>
                      <h3>Digital Product</h3>  
                    </div>
                    <div className="sell-card disabled">
                        <img src="https://public-assets.instantdm.com/app-icons/shopping_1162499.png"/>
                        <h3>Social Commerce</h3>
                    </div>
                    <div className="sell-card disabled">
                        <img src="https://public-assets.instantdm.com/app-icons/educational-video_13972594.png"/>
                        <h3>Course</h3>
                    </div>
                    
                </div>

            </div>

            <Drawer open={showCreateDrawer != false}
            title="What are you selling today?"
            width={"900px"}
            onClose={() => setShowCreateDrawer(false)}
            style={{backgroundColor:"rgb(245, 245, 255)"}}
            >

                {showCreateDrawer == "digital_prod" && <SellDigitalProduct />}
            


            </Drawer>


        </div>
    )
}